import { render, staticRenderFns } from "./RandomWords.vue?vue&type=template&id=47b53b98&"
import script from "./RandomWords.vue?vue&type=script&lang=js&"
export * from "./RandomWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RandomWords.vue"
export default component.exports